module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "acknow"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pvii"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiAkerman0006#racknow"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('a', {
    staticClass: "page"
  }), _vm._v("The eight chapters in this volume were originally presented as the Seventeenth Kenneth Nebenzahl, Jr., Lectures in the History of Cartography at the Newberry Library in late 2010. Throughout the book’s gestation, the authors have exhibited exemplary forbearance and have responded to repeated editorial requests both cheerfully and constructively. The editor wishes to acknowledge in particular the unusual amount of effort the authors expended in obtaining images and permissions for the book’s complex illustration program. Several anonymous readers offered invaluable critiques and timely advice on both the substance and the structure of the volume, while giving us the confidence to move forward. The University of Chicago Press has been unwavering in their support for this project, and its staff both collegial and professional at every turn. The enduring material and moral support of the Newberry Library, the host of the Nebenzahl Lectures since 1966, is foundational. Without this extraordinary community of creative librarians, curators, teachers, and readers dedicated to free inquiry in the humanities, there would be no Nebenzahl Lectures. In the autumn of 2016 the Nebenzahl Lectures celebrated their fiftieth anniversary. This collection is dedicated to Ken and Jossy Nebenzahl in honor of their kind and enduring sponsorship of this series and the scholarship it has promoted.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d42fbc0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Akerman-0007.vue
// module id = 72
// module chunks = 0